import React from 'react';
import LoginContainer from './LoginContainer';
import LoginStatic from './LoginStatic';

const LoginStaticContainer = ({
	onLoginSuccess,
	onBeforeSocialLogin,
	contextUsage,
	...props
}) => (
	<LoginContainer onLoginSuccess={onLoginSuccess} onBeforeSocialLogin={onBeforeSocialLogin} contextUsage={contextUsage}>
		{sharedProps => <LoginStatic {...sharedProps} {...props} />}
	</LoginContainer>
);

export default LoginStaticContainer;
